// Image / video lightbox overlay (no dependencies). Renders into <body> so it
// stacks above any pane and survives re-renders.
import { getMediaForDownload } from "../api/whatsapp.js";

let host = null;
let onKeyDownGlobal = null;

function ensureHost() {
  if (host) return host;
  host = document.createElement("div");
  host.id = "wa-lightbox-host";
  host.className = "wa-lightbox-host";
  host.style.display = "none";
  host.addEventListener("click", (e) => {
    // close when click is on the backdrop, not on the media itself
    if (e.target === host) close();
  });
  document.body.appendChild(host);
  return host;
}

/** Abre o overlay com a mídia. messageId é opcional — quando passado, mostra
 *  um botão "Baixar" no canto que faz refetch do servidor lendo o Content-
 *  Disposition pra salvar com filename + extensão correta (vs right-click
 *  Save Image As que usa o UUID do blob URL). */
export function openLightbox({ src, kind = "image", caption = "", messageId = null } = {}) {
  if (!src) return;
  const h = ensureHost();
  h.innerHTML = "";

  const close_btn = document.createElement("button");
  close_btn.className = "wa-lightbox-close";
  close_btn.title = "Fechar (Esc)";
  close_btn.innerHTML = "&times;";
  close_btn.addEventListener("click", close);
  h.appendChild(close_btn);

  if (messageId) {
    const dl_btn = document.createElement("button");
    dl_btn.className = "wa-lightbox-download";
    dl_btn.title = "Baixar arquivo";
    dl_btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
    dl_btn.addEventListener("click", async (ev) => {
      ev.stopPropagation();
      dl_btn.disabled = true;
      try {
        const fallback = `${kind === "video" ? "video" : "imagem"}-${messageId}.${kind === "video" ? "mp4" : "jpg"}`;
        const { url, filename } = await getMediaForDownload(messageId, fallback);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename || fallback;
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (err) {
        console.warn("[lightbox] download failed", err);
      } finally {
        dl_btn.disabled = false;
      }
    });
    h.appendChild(dl_btn);
  }

  const wrap = document.createElement("div");
  wrap.className = "wa-lightbox-content";

  let media;
  if (kind === "video") {
    media = document.createElement("video");
    media.src = src;
    media.controls = true;
    media.autoplay = true;
    media.className = "wa-lightbox-video";
  } else {
    media = document.createElement("img");
    media.src = src;
    media.alt = caption || "Imagem";
    media.className = "wa-lightbox-image";
  }
  wrap.appendChild(media);

  if (caption) {
    const cap = document.createElement("div");
    cap.className = "wa-lightbox-caption";
    cap.textContent = caption;
    wrap.appendChild(cap);
  }

  h.appendChild(wrap);
  h.style.display = "flex";

  if (!onKeyDownGlobal) {
    onKeyDownGlobal = (ev) => { if (ev.key === "Escape") close(); };
    document.addEventListener("keydown", onKeyDownGlobal);
  }
}

export function close() {
  if (!host) return;
  host.style.display = "none";
  host.innerHTML = "";
  if (onKeyDownGlobal) {
    document.removeEventListener("keydown", onKeyDownGlobal);
    onKeyDownGlobal = null;
  }
}
